import styled from "styled-components";

export const PortalWrapperContainer = styled.div`
    & > * {
        pointer-events: initial;
    }
`;
